import appApi from "@/api/appApi";

const existings = {};

const nameToApis = {
  heroes: "/match/heroes-list"
};

export default {
  async getDictionary(name) {
    if (existings[name]) return existings[name];

    const url = nameToApis[name];
    if (!url) {
      console.warn(`dictionary api "${name}" was not found`);
      return;
    }

    const { data } = await appApi.get(url);

    return data;
  }
};
